"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _errorMessage = _interopRequireDefault(require("./error-message"));

var _label = _interopRequireWildcard(require("./label"));

var _classnames = _interopRequireDefault(require("classnames"));

var _textfield = _interopRequireDefault(require("./textfield.scss"));

var _dropdown = _interopRequireDefault(require("./dropdown.scss"));

var _index = _interopRequireDefault(require("../icon/index"));

var _field = require("./field");

var _fieldsize = _interopRequireWildcard(require("./fieldsize"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Dropdown = function Dropdown(props) {
  var _cx, _cx2, _cx3;

  var renderOptions = function renderOptions() {
    return props.options.map(function (option, i) {
      return _react["default"].createElement("option", (0, _extends2["default"])({
        key: i
      }, option), option.label || option.value);
    });
  };

  var id = props.id || (0, _field.makeIdString)();
  var valueProps = props.value !== undefined ? {
    value: props.value
  } : {};
  return _react["default"].createElement("span", {
    className: (0, _classnames["default"])(_dropdown["default"].Dropdown, props.classNames.wrapper)
  }, _react["default"].createElement(_label["default"], {
    className: (0, _classnames["default"])(props.classNames.label, (_cx = {}, (0, _defineProperty2["default"])(_cx, _textfield["default"].errorLabel, props.errorMessage), (0, _defineProperty2["default"])(_cx, props.classNames.labelDisabled, props.disabled), _cx)),
    "for": id,
    tooltip: props.tooltip,
    size: props.size
  }, props.label), _react["default"].createElement(_label.SubLabel, {
    className: (0, _classnames["default"])(props.classNames.subLabel, (_cx2 = {}, (0, _defineProperty2["default"])(_cx2, _textfield["default"].errorLabel, props.errorMessage), (0, _defineProperty2["default"])(_cx2, _dropdown["default"].labelDisabled, props.disabled), (0, _defineProperty2["default"])(_cx2, props.classNames.labelDisabled, props.disabled), _cx2)),
    size: props.size
  }, props.subLabel), _react["default"].createElement("span", {
    className: _dropdown["default"].fieldIconContainer
  }, _react["default"].createElement("select", (0, _extends2["default"])({}, valueProps, {
    disabled: props.disabled,
    name: props.name,
    id: id,
    "data-test-id": props.dataTestId,
    onChange: props.onChange,
    "aria-label": props.ariaLabel,
    onFocus: props.onFocus,
    onClick: props.onClick,
    className: (0, _classnames["default"])(_dropdown["default"].field, (_cx3 = {}, (0, _defineProperty2["default"])(_cx3, _dropdown["default"].fieldInvalid, props.errorMessage), (0, _defineProperty2["default"])(_cx3, _dropdown["default"].selectDisabled, props.disabled), (0, _defineProperty2["default"])(_cx3, props.classNames.selectDisabled, props.disabled), (0, _defineProperty2["default"])(_cx3, _dropdown["default"].fieldSmall, props.size === _fieldsize["default"].SMALL), (0, _defineProperty2["default"])(_cx3, _dropdown["default"].fieldDefault, props.size === _fieldsize["default"].DEFAULT), _cx3), props.classNames.field)
  }), renderOptions()), _react["default"].createElement(_index["default"], {
    type: 'chevron-down',
    size: "small",
    className: _dropdown["default"].icon,
    role: "presentation"
  })), props.errorMessage && _react["default"].createElement(_errorMessage["default"], {
    message: props.errorMessage,
    className: props.classNames.errorMessage,
    size: props.size
  }));
};

Dropdown.propTypes = _objectSpread({}, _field.fieldPropTypes, {}, _fieldsize.fieldSizePropTypes, {
  options: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    label: _propTypes["default"].string.isRequired,
    value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number])
  })).isRequired,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  disabled: _propTypes["default"].bool,
  classNames: _propTypes["default"].shape({
    wrapper: _propTypes["default"].string,
    label: _propTypes["default"].string,
    subLabel: _propTypes["default"].string,
    field: _propTypes["default"].string,
    errorMessage: _propTypes["default"].string,
    labelDisabled: _propTypes["default"].string,
    selectDisabled: _propTypes["default"].string
  })
});
Dropdown.defaultProps = _objectSpread({
  disabled: false,
  classNames: {}
}, _fieldsize.fieldSizeDefaultProps);
var _default = Dropdown;
exports["default"] = _default;